import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
} from "react-bootstrap";
import { useFadeIn } from "../App";
import ShapeDivider from "../components/ShapeDivider";
import { getImageById } from "../data/wildlifeGallery";

const Contact = () => {
  const [heroRef, heroVisible] = useFadeIn();
  const [formRef, formVisible] = useFadeIn();
  const [infoRef, infoVisible] = useFadeIn();
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
    e.target.reset();
  };

  return (
    <>
      {/* Hero Section */}
      <section
        ref={heroRef}
        className={`hero-contact-section fade-in-section ${heroVisible ? "is-visible" : ""}`}
        style={{
          backgroundImage: `linear-gradient(rgba(74, 92, 45, 0.85), rgba(141, 191, 75, 0.85)), url(${getImageById('parakeet-detail').url})`,
          padding: "120px 0 80px",
          color: "white",
          position: "relative",
          overflow: "hidden",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed"
        }}
      >
        <div
          className="hero-pattern"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage:
              'url("data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="%23ffffff" fill-opacity="0.06"%3E%3Cpath d="M20 20l10-10h-6l-4 4-4-4h-6l10 10zm0 0l10 10h-6l-4-4-4 4h-6l10-10z"/%3E%3C/g%3E%3C/svg%3E")',
            opacity: 0.3,
          }}
        ></div>
        <Container className="position-relative">
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <div
                className="hero-icon mb-4"
                style={{
                  width: "100px",
                  height: "100px",
                  background: "rgba(255, 255, 255, 0.15)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                  fontSize: "3rem",
                  backdropFilter: "blur(10px)",
                  border: "2px solid rgba(255, 255, 255, 0.2)",
                }}
              >
                <i className="fas fa-comments"></i>
              </div>
              <h1 className="display-3 fw-bold mb-4" style={{ color: "white" }}>
                Get In Touch
              </h1>
              <p
                className="lead mb-5"
                style={{ fontSize: "1.3rem", opacity: 0.95 }}
              >
                Have questions about wildlife care? Want to volunteer? Need help
                with an injured animal? We're here to help.
              </p>
            </Col>
          </Row>
        </Container>
        <ShapeDivider color="white" />
      </section>

      {/* Contact Form and Info Section */}
      <section style={{ padding: "100px 0" }}>
        <Container>
          <Row className="g-5">
            {/* Contact Form */}
            <Col lg={7}>
              <div
                ref={formRef}
                className={`contact-form fade-in-section ${formVisible ? "is-visible" : ""}`}
              >
                <Card
                  className="border-0 shadow-lg"
                  style={{
                    borderRadius: "20px",
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(249,247,242,0.98) 100%)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Card.Header
                    className="border-0 text-center py-4"
                    style={{
                      background:
                        "linear-gradient(135deg, var(--primary-yellow) 0%, #e6b73e 100%)",
                      color: "white",
                      borderRadius: "20px 20px 0 0",
                    }}
                  >
                    <h3 className="mb-0 fw-bold">
                      <i className="fas fa-envelope me-2"></i>
                      Send Us a Message
                    </h3>
                  </Card.Header>
                  <Card.Body className="p-5">
                    {showAlert && (
                      <Alert variant="success" className="mb-4">
                        <i className="fas fa-check-circle me-2"></i>
                        Thank you for your message! We'll get back to you soon.
                      </Alert>
                    )}
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label
                              className="fw-semibold"
                              style={{ color: "var(--primary-green)" }}
                            >
                              Full Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your full name"
                              required
                              style={{
                                borderRadius: "12px",
                                border: "2px solid #e9ecef",
                                padding: "12px 16px",
                                fontSize: "1rem",
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label
                              className="fw-semibold"
                              style={{ color: "var(--primary-green)" }}
                            >
                              Email Address
                            </Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Enter your email address"
                              required
                              style={{
                                borderRadius: "12px",
                                border: "2px solid #e9ecef",
                                padding: "12px 16px",
                                fontSize: "1rem",
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Form.Group className="mb-4">
                        <Form.Label
                          className="fw-semibold"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Phone Number (Optional)
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter your phone number"
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                          }}
                        />
                      </Form.Group>
                      <Form.Group className="mb-4">
                        <Form.Label
                          className="fw-semibold"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Subject
                        </Form.Label>
                        <Form.Select
                          required
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                          }}
                        >
                          <option value="">Select a subject</option>
                          <option value="volunteer">
                            Volunteer Opportunities
                          </option>
                          <option value="emergency">Wildlife Emergency</option>
                          <option value="donation">Donation Inquiry</option>
                          <option value="education">Education Programmes</option>
                          <option value="general">General Inquiry</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group className="mb-4">
                        <Form.Label
                          className="fw-semibold"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Message
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          placeholder="Tell us how we can help you..."
                          required
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                            resize: "vertical",
                          }}
                        />
                      </Form.Group>
                      <Button
                        type="submit"
                        size="lg"
                        className="w-100"
                        style={{
                          borderRadius: "12px",
                          padding: "15px",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        <i className="fas fa-paper-plane me-2"></i>
                        Send Message
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </Col>

            {/* Contact Information */}
            <Col lg={5}>
              <div
                ref={infoRef}
                className={`contact-info fade-in-section ${infoVisible ? "is-visible" : ""}`}
              >
                {/* Emergency Card */}
                <Card
                  className="emergency-card border-0 shadow-lg mb-4"
                  style={{
                    borderRadius: "20px",
                    background:
                      "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                    color: "white",
                  }}
                >
                  <Card.Body className="p-4 text-center">
                    <div
                      className="emergency-icon mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        fontSize: "1.5rem",
                      }}
                    >
                      <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <h5
                      className="fw-bold mb-2"
                      style={{
                        color: "white",
                        textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                      }}
                    >
                      Wildlife Emergency?
                    </h5>
                    <p
                      className="mb-3"
                      style={{
                        color: "white",
                        fontWeight: "500",
                        textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                      }}
                    >
                      If you've found an injured animal, contact your local
                      wildlife rescue immediately
                    </p>
                    <Button
                      variant="light"
                      size="sm"
                      style={{ borderRadius: "20px", fontWeight: "600" }}
                    >
                      Emergency Contacts
                    </Button>
                  </Card.Body>
                </Card>

                {/* Contact Details Card */}
                <Card
                  className="contact-details-card border-0 shadow-lg"
                  style={{
                    borderRadius: "20px",
                    background: "white",
                  }}
                >
                  <Card.Body className="p-4">
                    <h4
                      className="fw-bold mb-4"
                      style={{ color: "var(--primary-green)" }}
                    >
                      <i className="fas fa-info-circle me-2"></i>
                      Contact Information
                    </h4>

                    <div className="contact-item mb-4">
                      <div
                        className="contact-icon"
                        style={{
                          width: "50px",
                          height: "50px",
                          background:
                            "linear-gradient(135deg, var(--primary-yellow) 0%, #e6b73e 100%)",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "1.2rem",
                          float: "left",
                          marginRight: "15px",
                        }}
                      >
                        <i className="fas fa-envelope"></i>
                      </div>
                      <div>
                        <h6
                          className="fw-bold mb-1"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Email
                        </h6>
                        <a
                          href="mailto:jen@aussiewildlife.org.au"
                          style={{
                            textDecoration: "none",
                            color: "var(--dark-text)",
                          }}
                        >
                          jen@aussiewildlife.org.au
                        </a>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>

                    <div className="contact-item mb-4">
                      <div
                        className="contact-icon"
                        style={{
                          width: "50px",
                          height: "50px",
                          background:
                            "linear-gradient(135deg, var(--primary-green) 0%, var(--accent-green) 100%)",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "1.2rem",
                          float: "left",
                          marginRight: "15px",
                        }}
                      >
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <div>
                        <h6
                          className="fw-bold mb-1"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Address
                        </h6>
                        <p className="mb-0 text-muted">
                          Gold Coast, QLD, Australia
                        </p>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>

                    <div className="contact-item mb-4">
                      <div
                        className="contact-icon"
                        style={{
                          width: "50px",
                          height: "50px",
                          background:
                            "linear-gradient(135deg, #1877f2 0%, #0d5bb8 100%)",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "1.2rem",
                          float: "left",
                          marginRight: "15px",
                        }}
                      >
                        <i className="fab fa-facebook-f"></i>
                      </div>
                      <div>
                        <h6
                          className="fw-bold mb-1"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Facebook
                        </h6>
                        <a
                          href="https://www.facebook.com/AussieWildlife1"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "var(--dark-text)",
                          }}
                        >
                          @AussieWildlife1
                        </a>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>

                    <div className="contact-item mb-4">
                      <div
                        className="contact-icon"
                        style={{
                          width: "50px",
                          height: "50px",
                          background:
                            "linear-gradient(135deg, #e4405f 0%, #c13584 100%)",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "1.2rem",
                          float: "left",
                          marginRight: "15px",
                        }}
                      >
                        <i className="fab fa-instagram"></i>
                      </div>
                      <div>
                        <h6
                          className="fw-bold mb-1"
                          style={{ color: "var(--primary-green)" }}
                        >
                          Instagram
                        </h6>
                        <a
                          href="https://www.instagram.com/aussiewildlife_limited"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "var(--dark-text)",
                          }}
                        >
                          @aussiewildlife_limited
                        </a>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>

                    <div className="contact-item mb-4">
                      <div
                        className="contact-icon"
                        style={{
                          width: "50px",
                          height: "50px",
                          background:
                            "linear-gradient(135deg, #0077b5 0%, #005885 100%)",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "1.2rem",
                          float: "left",
                          marginRight: "15px",
                        }}
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </div>
                      <div>
                        <h6
                          className="fw-bold mb-1"
                          style={{ color: "var(--primary-green)" }}
                        >
                          LinkedIn
                        </h6>
                        <a
                          href="https://www.linkedin.com/company/aussie-wildlife-limited/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "var(--dark-text)",
                          }}
                        >
                          Aussie Wildlife Limited
                        </a>
                      </div>
                      <div style={{ clear: "both" }}></div>
                    </div>

                    <hr style={{ margin: "2rem 0" }} />

                    <div className="response-time text-center">
                      <h6
                        className="fw-bold mb-2"
                        style={{ color: "var(--primary-green)" }}
                      >
                        <i className="fas fa-clock me-2"></i>
                        Response Time
                      </h6>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "0.95rem" }}
                      >
                        We typically respond to messages within 24-48 hours
                        during business days.
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
